import { FlowButton } from './ui/flow-button';
import './SiteHeroCtas.css';

// Button appearance and motion live in FlowButton; these hooks only arrange hero actions.
export const HERO_CTA_PRIMARY_CLASS = 'inline-flex items-center justify-center';
export const HERO_CTA_SECONDARY_CLASS = 'inline-flex items-center justify-center';
export const PAGE_HERO_SECTION_CLASS = 'site-hero relative flex min-h-[100svh] items-center overflow-hidden md:min-h-[83vh]';
export const PAGE_HERO_CONTAINER_CLASS = 'site-content-shell relative z-10 pt-28 pb-16';
export const PAGE_HERO_CONTENT_CLASS = 'w-full max-w-[342px] sm:max-w-4xl';
export const PAGE_HERO_EYEBROW_CLASS = 'reveal text-xs uppercase tracking-[0.3em] text-accent-ink font-body mb-6';
export const PAGE_HERO_H1_CLASS = 'reveal reveal-delay-1 font-display text-4xl sm:text-6xl lg:text-[4rem] tracking-tighter leading-[0.98] text-ink font-bold mb-8';
export const PAGE_HERO_BODY_CLASS = 'reveal reveal-delay-2 font-body text-copy/58 text-base md:text-lg leading-[1.7] max-w-3xl mb-10 space-y-4';
export const PAGE_HERO_BODY_TEXT_CLASS = 'reveal reveal-delay-2 font-body text-copy/58 text-base md:text-lg leading-[1.7] max-w-3xl mb-10';
export const PAGE_HERO_CTA_ROW_CLASS = 'site-hero-ctas reveal reveal-delay-3 flex flex-wrap gap-4';

const DEFAULT_PRIMARY = HERO_CTA_PRIMARY_CLASS;
const DEFAULT_SECONDARY = HERO_CTA_SECONDARY_CLASS;

function isAnchorPath(path) {
  return String(path || '').startsWith('#');
}

function CtaLink({ path, className, children, showArrow = false, actionComponent: Action = FlowButton }) {
  return <Action {...(isAnchorPath(path) ? { as: 'a', href: path } : { to: path })} className={className} showArrow={showArrow}>{children}</Action>;
}

export default function SiteHeroCtas({
  content,
  className = 'reveal reveal-delay-3 mt-10 flex flex-wrap gap-4',
  primaryClassName = DEFAULT_PRIMARY,
  secondaryClassName = DEFAULT_SECONDARY,
  tertiaryClassName = DEFAULT_SECONDARY,
  showArrow = true,
  actionComponent,
}) {
  const actions = [
    [content?.primaryCtaLabel, content?.primaryCtaPath, primaryClassName],
    [content?.secondaryCtaLabel, content?.secondaryCtaPath, secondaryClassName],
    [content?.tertiaryCtaLabel, content?.tertiaryCtaPath, tertiaryClassName],
  ].filter(([label, path]) => label && path);

  if (!actions.length) {
    return null;
  }

  const containerClassName = className.includes('reveal') && !className.includes('visible')
    ? `${className} visible`
    : className;

  return (
    <div className={`site-hero-ctas ${containerClassName}`}>
      {actions.map(([label, path, actionClassName]) => (
        <CtaLink key={`${label}-${path}`} path={path} actionComponent={actionComponent} className={actionClassName} showArrow={showArrow}>
          {label}
        </CtaLink>
      ))}
    </div>
  );
}
